// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/javascript/style/main-jquery.scss
// module id = 137
// module chunks = 1